export type FencedCodeSegment = {
  kind: 'code';
  info: string;
  language: string;
  content: string;
};

export type MarkdownSegment = {
  kind: 'markdown';
  content: string;
};

export type FencedCodeTextSegment = MarkdownSegment | FencedCodeSegment;

const FENCED_CODE_BLOCK_PATTERN = /```([^\n`]*)\n([\s\S]*?)```/;

function normalizeFenceLanguage(info: string): string {
  return info.trim().split(/\s+/)[0]?.toLowerCase() ?? '';
}

function stripSingleTrailingNewline(content: string): string {
  return content.endsWith('\n') ? content.slice(0, -1) : content;
}

export function restoreFencedCodeMarkdown(segment: FencedCodeSegment): string {
  return `\`\`\`${segment.info}\n${segment.content}\n\`\`\``;
}

export function extractFencedCodeSegments(raw: string): Array<FencedCodeTextSegment> {
  const segments: Array<FencedCodeTextSegment> = [];
  let cursor = 0;
  let match: RegExpExecArray | null;

  const regex = new RegExp(FENCED_CODE_BLOCK_PATTERN.source, 'g');

  while ((match = regex.exec(raw)) !== null) {
    const before = raw.slice(cursor, match.index);
    if (before.trim()) {
      segments.push({ kind: 'markdown', content: before.trim() });
    }

    const info = match[1].trim();
    segments.push({
      kind: 'code',
      info,
      language: normalizeFenceLanguage(info),
      content: stripSingleTrailingNewline(match[2]),
    });

    cursor = match.index + match[0].length;
  }

  const trailing = raw.slice(cursor);
  if (trailing.trim()) {
    segments.push({ kind: 'markdown', content: trailing.trim() });
  }

  return segments.length > 0 ? segments : [{ kind: 'markdown', content: raw }];
}
